/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiPaginatedResponseOfSponsorResponse } from '../model';
// @ts-ignore
import { ApiResponseOfSponsorResponse } from '../model';
// @ts-ignore
import { ApiResponseOfSponsorResponseArray } from '../model';
// @ts-ignore
import { SponsorBody } from '../model';
/**
 * SponsorApi - axios parameter creator
 * @export
 */
export const SponsorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new sponsor
         * @param {SponsorBody} sponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (sponsorBody: SponsorBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sponsorBody' is not null or undefined
            assertParamExists('create', 'sponsorBody', sponsorBody)
            const localVarPath = `/api/v1/sponsor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sponsorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all sponsors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sponsor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List sponsors with pagination
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (limit?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sponsor/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete sponsor by ID
         * @param {string} sponsorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (sponsorId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sponsorId' is not null or undefined
            assertParamExists('remove', 'sponsorId', sponsorId)
            const localVarPath = `/api/v1/sponsor/{sponsorId}`
                .replace(`{${"sponsorId"}}`, encodeURIComponent(String(sponsorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sponsor by ID
         * @param {string} sponsorId 
         * @param {SponsorBody} sponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (sponsorId: string, sponsorBody: SponsorBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sponsorId' is not null or undefined
            assertParamExists('update', 'sponsorId', sponsorId)
            // verify required parameter 'sponsorBody' is not null or undefined
            assertParamExists('update', 'sponsorBody', sponsorBody)
            const localVarPath = `/api/v1/sponsor/{sponsorId}`
                .replace(`{${"sponsorId"}}`, encodeURIComponent(String(sponsorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sponsorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SponsorApi - functional programming interface
 * @export
 */
export const SponsorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SponsorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new sponsor
         * @param {SponsorBody} sponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(sponsorBody: SponsorBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSponsorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(sponsorBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all sponsors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSponsorResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List sponsors with pagination
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(limit?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaginatedResponseOfSponsorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete sponsor by ID
         * @param {string} sponsorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(sponsorId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(sponsorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update sponsor by ID
         * @param {string} sponsorId 
         * @param {SponsorBody} sponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(sponsorId: string, sponsorBody: SponsorBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSponsorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(sponsorId, sponsorBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SponsorApi - factory interface
 * @export
 */
export const SponsorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SponsorApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new sponsor
         * @param {SponsorBody} sponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(sponsorBody: SponsorBody, options?: any): AxiosPromise<ApiResponseOfSponsorResponse> {
            return localVarFp.create(sponsorBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all sponsors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<ApiResponseOfSponsorResponseArray> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List sponsors with pagination
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(limit?: number, page?: number, options?: any): AxiosPromise<ApiPaginatedResponseOfSponsorResponse> {
            return localVarFp.getPaginated(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete sponsor by ID
         * @param {string} sponsorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(sponsorId: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(sponsorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sponsor by ID
         * @param {string} sponsorId 
         * @param {SponsorBody} sponsorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(sponsorId: string, sponsorBody: SponsorBody, options?: any): AxiosPromise<ApiResponseOfSponsorResponse> {
            return localVarFp.update(sponsorId, sponsorBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SponsorApi - interface
 * @export
 * @interface SponsorApi
 */
export interface SponsorApiInterface {
    /**
     * 
     * @summary Create new sponsor
     * @param {SponsorBody} sponsorBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApiInterface
     */
    create(sponsorBody: SponsorBody, options?: any): AxiosPromise<ApiResponseOfSponsorResponse>;

    /**
     * 
     * @summary List all sponsors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApiInterface
     */
    getAll(options?: any): AxiosPromise<ApiResponseOfSponsorResponseArray>;

    /**
     * 
     * @summary List sponsors with pagination
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApiInterface
     */
    getPaginated(limit?: number, page?: number, options?: any): AxiosPromise<ApiPaginatedResponseOfSponsorResponse>;

    /**
     * 
     * @summary Delete sponsor by ID
     * @param {string} sponsorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApiInterface
     */
    remove(sponsorId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @summary Update sponsor by ID
     * @param {string} sponsorId 
     * @param {SponsorBody} sponsorBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApiInterface
     */
    update(sponsorId: string, sponsorBody: SponsorBody, options?: any): AxiosPromise<ApiResponseOfSponsorResponse>;

}

/**
 * SponsorApi - object-oriented interface
 * @export
 * @class SponsorApi
 * @extends {BaseAPI}
 */
export class SponsorApi extends BaseAPI implements SponsorApiInterface {
    /**
     * 
     * @summary Create new sponsor
     * @param {SponsorBody} sponsorBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public create(sponsorBody: SponsorBody, options?: any) {
        return SponsorApiFp(this.configuration).create(sponsorBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all sponsors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public getAll(options?: any) {
        return SponsorApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List sponsors with pagination
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public getPaginated(limit?: number, page?: number, options?: any) {
        return SponsorApiFp(this.configuration).getPaginated(limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete sponsor by ID
     * @param {string} sponsorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public remove(sponsorId: string, options?: any) {
        return SponsorApiFp(this.configuration).remove(sponsorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sponsor by ID
     * @param {string} sponsorId 
     * @param {SponsorBody} sponsorBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SponsorApi
     */
    public update(sponsorId: string, sponsorBody: SponsorBody, options?: any) {
        return SponsorApiFp(this.configuration).update(sponsorId, sponsorBody, options).then((request) => request(this.axios, this.basePath));
    }
}
